import { initPriceRange } from '@theme/snippet-price-range-script';
import { BREAKPOINTS } from '@theme/utilities';

/**
 * @typedef {HTMLElement & { prepareForSubmission?: () => void }} PriceRangeElement
 */

/**
 * @param {HTMLFormElement} formElement
 */
function submitFilterForm(formElement) {
  formElement.querySelectorAll('[data-price-range]').forEach((element) => {
    const priceRange = /** @type {PriceRangeElement} */ (element);
    if (typeof priceRange.prepareForSubmission === 'function') {
      priceRange.prepareForSubmission();
    }
  });

  if (typeof formElement.requestSubmit === 'function') {
    formElement.requestSubmit();
    return;
  }

  formElement.submit();
}

/**
 * @param {HTMLDetailsElement} openedGroup
 */
function closeSiblingFilterGroups(openedGroup) {
  const form = openedGroup.closest('form.collection-filters');
  if (!form) {
    return;
  }

  form.querySelectorAll('.collection-filters__group').forEach((group) => {
    if (group !== openedGroup && group instanceof HTMLDetailsElement) {
      group.open = false;
    }
  });
}

/**
 * @param {HTMLFormElement} form
 */
function initMobileExclusiveAccordion(form) {
  const mobileQuery = window.matchMedia(
    `(max-width: ${BREAKPOINTS.mobileMax}px)`
  );

  /**
   * @param {Event} event
   */
  const handleToggle = (event) => {
    if (!mobileQuery.matches) {
      return;
    }

    const target = event.target;
    if (!(target instanceof HTMLDetailsElement)) {
      return;
    }

    if (!target.open) {
      return;
    }

    closeSiblingFilterGroups(target);
  };

  form.querySelectorAll('.collection-filters__group').forEach((group) => {
    group.addEventListener('toggle', handleToggle);
  });
}

/**
 * @param {HTMLFormElement} form
 */
function initCollectionFilters(form) {
  if (form.dataset.collectionFiltersBound === 'true') {
    return;
  }

  form.dataset.collectionFiltersBound = 'true';

  form.querySelectorAll('[data-price-range]').forEach((root) => {
    if (root instanceof HTMLElement) {
      initPriceRange(root);
    }
  });

  form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.addEventListener('change', () => {
      submitFilterForm(form);
    });
  });

  initMobileExclusiveAccordion(form);
}

document.querySelectorAll('.collection-filters').forEach((form) => {
  if (form instanceof HTMLFormElement) {
    initCollectionFilters(form);
  }
});
